<template>
  <DynamicPageRendered :theme="theme" :page="page"></DynamicPageRendered>
</template>

<script setup>
import { computed } from 'vue'

import pagesConfig from '@/project/pages/pagesConfigs'
import DynamicPageRendered from './DynamicPageRendered.vue'

const props = defineProps({
  pageName: { type: String, default: '' },
})

const theme = pagesConfig.theme
const page = computed(() => {
  return pagesConfig.pagesMap[props.pageName] || {}
})
</script>
